const phases = {
  SELF_MANAGEMENT: 'Self Management',
  ONBOARDING: 'Onboarding',
};

export default phases;
